import { Component, OnInit, Output, EventEmitter, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { AppUrls } from '../../../utility/appurls';
import { GenericLookupForm } from '../generic-lookup-form';
import { MaskUtility } from '../../../utility/mask-utility';
import { MaskConfig } from '../../../utility/mask-config';
import { FieldLabelConstants } from 'projects/bis-shared/src/lib/utility/field-label-constants';
import { DynamicFormsService } from '../../../dynamic-forms/services/dynamic-forms/dynamic-forms.service';
import { UserInputOptionType } from 'projects/bis-shared/src/lib/shared-models/user-input-option-type';
import { FormsModule } from '@angular/forms';
import { DynamicFormLoadDirective } from '../../../dynamic-forms/directives/dynamic-form-structural.directive';
import { TextInputComponent } from '../../../dynamic-forms/dynamic-form-inputs/text-input/text-input.component';
import { GenericInputComponent } from '../../../dynamic-forms/dynamic-form-inputs/generic-input/generic-input.component';
import { SelectInputComponent } from '../../../dynamic-forms/dynamic-form-inputs/select-input/select-input.component';

@Component({
  selector: 'app-employer-lookup-form',
  templateUrl: './employer-lookup-form.component.html',
  styleUrls: ['./employer-lookup-form.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [FormsModule, DynamicFormLoadDirective , TextInputComponent, GenericInputComponent, SelectInputComponent],
     
})
export class EmployerLookupFormComponent extends GenericLookupForm implements OnInit {
  private dynamicFormsService = inject(DynamicFormsService);

  @Output() enterKey: EventEmitter<any> = new EventEmitter();
  formLoaded = false;
  AppUrls = AppUrls;

  feinMaskConfig: MaskConfig;
  FieldLabelConstants = FieldLabelConstants;

  
 

  constructor() {
    super();
  }

  ngOnInit() {
    this.dynamicFormsService.getFormGroupForModel('employerLookup').subscribe(formInfo => {
      this.formInfo = formInfo;
      this.form = formInfo.formGroup;
      this.formLoaded = true;
    });
  }

  search() {
    this.enterKey.emit();
  }

  onFeinChange() {
    this.feinMaskConfig = MaskUtility.getFEINMask();
  }

  public reset(): void {
    this.form.reset({
      nameSearchOptionType: UserInputOptionType.Contains,
    });
  }

  public isValid(): boolean {
    // Valid means that some value has been entered

    return this.form && this.form.valid;
  }
}
